"use client"

import { Stack, styled } from "@mui/material"

const PageContainer = styled(Stack)({
  paddingLeft: "24px",
  paddingRight: "24px",
  alignItems: "center",
  width: "100%",
})

export default PageContainer
